import { ElectricalAspectService } from '../model/electrical-aspect.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { ElectricalAspect } from 'assets-model';
import { Observable } from 'rxjs';


export class ElectricalAspectDataSource extends CrudDataSource<ElectricalAspect> {

  constructor(private service: ElectricalAspectService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<ElectricalAspect>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


